import React from 'react';
import Asset from '../../requests/apa/Asset';

const PersistentMiniEpgChannel = () => {
  return(
    <div className="mini-channel-container mini-row">
      <div className="mini-channel-container-float">
        <div className="mini-channel-number-container mini-row">
          <span id="mini-channel-number-label"></span>
          <div id="mini-channel-fav-icon">
            <img  src={Asset.get('playingLive_program_option_button_favorites', '/images/ic_favorite.png')} alt="fav"/>
          </div>
        </div>
        <div
          className="mini-row"
          id="mini-channel-image-container"
          style={{ display: 'none' }}>
          <div className="mini-channel-image-float">
            <img id="mini-channel-image" alt="logo-channel"/>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PersistentMiniEpgChannel;



// WEBPACK FOOTER //
// ./src/components/PersistentMiniEpg/PersistentMiniEpgChannel.jsx